const removeTags = (text: string) =>
  text.replace(/<br\s*\/?>/gi, '\n').replace(/<\/?[^>]+(>|$)/g, '')

export default removeTags
